var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.897 1.02581L6.20153 10.8914C6.06415 11.0362 5.88097 11.0362 5.74359 10.8914L0.103037 5.0626C-0.034346 4.91778 -0.034346 4.72469 0.103037 4.57987L0.515185 4.14541C0.652568 4.00059 0.835745 4.00059 0.973128 4.14541L5.97256 9.29837L15.0269 0.108615C15.1643 -0.036205 15.3474 -0.036205 15.439 0.108615L15.897 0.543075C16.0343 0.687895 16.0343 0.880988 15.897 1.02581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon2);
export default __webpack_public_path__ + "static/media/check_icon2.46e6dfea6dd7e6f5ee73f8d50946030c.svg";
export { ForwardRef as ReactComponent };